<template>
  <div
    class="as-nav-tabs-btn"
    :class="{
      'as-nav-tabs-btn__border': isShowBorder,
    }"
  >
    <div
      v-for="tab in tabs"
      :key="tab.key"
      class="as-nav-item"
      :class="{ active: activeTab === tab.key }"
      @click="changeTag(tab.key)"
    >
      {{ tab.title }}
    </div>
  </div>
</template>

<script setup lang="ts">
const emits = defineEmits(["change"]);

interface ITabsBtnItem {
  key: string;
  title: string;
}

interface IProps {
  tabs: ITabsBtnItem[];
  activeTab: string;
  isShowBorder?: boolean;
}

withDefaults(defineProps<IProps>(), {
  activeTab: "",
  isShowBorderTop: false,
});

const changeTag = (tag: string) => {
  emits("change", tag);
};
</script>

<script lang="ts">
export default {};
</script>
